// What the store page's Player Packs select shows (spec 2026-10-07). Display
// only — PUT /api/team-stores/:id/player-packs stays the authority. Mirrors v4
// computePlayerPackPlan / playerPacksFor: no packs without hanger
// personalization (a store set to mode off has none), and a store with no
// explicit setting gets the default.
// The default depends on the switch (GET /api/player-packs/switch, Grant
// 2026-10-08): packs on by default → a NEW store gets packs, a store already
// built (liveAt / productsCreatedAt) gets none; off (pilot) → no packs.
// Only `byDefault === true` is default-on.
// Player Packs are chosen before the build claims the store. Mirrors
// PACKS_EDITABLE in ghostfit-console/lib/player-packs-field.js (every status
// before creating_products, plus approved), minus rendering_proof (a proof is
// mid-render).
export const PACKS_EDITABLE: ReadonlySet<string> = new Set([
  'pending_review', 'pending_artwork', 'processing_artwork', 'artwork_ready', 'artwork_failed',
  'proof_sent', 'proof_email_failed', 'changes_requested', 'approved',
]);

export type PacksStore = {
  playerPacks?: { enabled: boolean; required: boolean } | null;
  personalization?: { hanger?: boolean; mode?: string; [k: string]: unknown } | null;
  liveAt?: unknown;
  productsCreatedAt?: unknown;
};
export type PacksSelectState = {
  value: 'off' | 'optional' | 'required';
  offLabel: string;
  needsPersonalization: boolean;
  pilot: boolean;
};

export function packsSelectState(store: PacksStore, byDefault?: boolean): PacksSelectState {
  const needsPersonalization = store.personalization?.hanger !== true || store.personalization?.mode === 'off';
  const pilot = byDefault !== true;
  const p = store.playerPacks;
  const unset = p == null;
  const legacy = !pilot && unset && !!(store.liveAt || store.productsCreatedAt);
  const offLabel = legacy ? 'Off (built before packs)' : pilot && unset ? 'Off (not set)' : 'Off';
  if (needsPersonalization || legacy) return { value: 'off', offLabel, needsPersonalization, pilot };
  const value = !p ? (pilot ? 'off' : 'optional') : p.enabled === false ? 'off' : p.required ? 'required' : 'optional';
  return { value, offLabel, needsPersonalization, pilot };
}
